import React from 'react';

import { Center } from '@chakra-ui/react';
import startCase from 'lodash/startCase';

const styles = {
  px: 3,
  borderRadius: 3,
  color: 'white',
};

export const renderImportance = (value: string) => {
  return (
    <Center {...styles} bg={value?.toLowerCase()}>
      {value?.toUpperCase()}
    </Center>
  );
};

export const renderRemediationEffort = (value: string) => {
  let bg = value?.toLowerCase();
  if (bg === 'low') bg = 'green.300';
  return (
    <Center bg={bg} fontSize="sm" {...styles}>
      {startCase(value)?.toUpperCase()}
    </Center>
  );
};

export const getRatingBgColor = value => {
  switch (value) {
    case 'Good':
      return 'green';
    case 'Average':
      return 'orange';
    case 'Poor':
      return 'red';
  }
};

export const getGovernanceRiskScore = score => score * 10;

export const getGovernanceHealthColor = score => {
  const percent = getGovernanceRiskScore(score);
  if (percent < 25) return '#f0bcba';
  if (percent >= 25 && percent < 50) return '#f8e2a7';
  if (percent >= 50 && percent < 75) return '#d2f7e9';
  else return '#a1cd63';
};

export const getGovernanceHealth = score => {
  const percent = getGovernanceRiskScore(score);
  if (percent < 25) return 'Poor';
  if (percent >= 25 && percent < 50) return 'Fair';
  if (percent >= 50 && percent < 75) return 'Good';
  else return 'Excellent';
};
